$(document).ready(function() {
  console.log("Add to cart");
  
  $( "#c-privy-gift-add" ).click(function() {
    console.log("Add to cart");
    var freeGiftItemID = $(this).data('variant-id');
	$(".privy-dismiss-content").click();
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=' + 1 + '&id=' + freeGiftItemID,
      dataType: 'json',
      success: function() {
        if ((typeof callback) === 'function') {
          callback(cart);
        }
        else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
           bubbles: true
       
         }));
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        if ((typeof errorCallback) === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        }
        else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
      }
    };
    jQuery.ajax(params);
});

  
  
});